import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import A_IconMust from '../A_IconMust'
import { createStyles, makeStyles } from '@material-ui/core'
// import { useMediaQueryContext } from 'MediaQueryProvider'

const useStyles = makeStyles(() =>
  createStyles({
    label: {
      width: 100,
      align: 'left',
    },
    labelMax: {
      width: 180,
      align: 'left',
    },
    labelNewLine: {
      width: '100%',
      align: 'left',
    },
    text: {
      flexGrow: 1,
      align: 'left',
      width: 'calc(100% - 100px)',
    },
    textLabelMax: {
      flexGrow: 1,
      align: 'left',
      width: 'calc(100% - 180px)',
    },
    textAtom: {
      width: '100%',
      height: 27,
      paddingTop: 0,
      paddingBottom: 0,
    },
  }),
)

type Props = {
  key?: number
  tab?: number
  must?: boolean
  type?: string
  label: string
  valueCode?: string
  labelWidth?: 0 | 1 | 2 // 0: 100px, 1: 180px, 2: 100%
  max?: number
  change?: (e: React.ChangeEvent<HTMLInputElement>) => void
  blurFunc?: (e: React.FocusEvent<HTMLInputElement>) => void
  register?: {
    onKeyDown({ key }: { key: string }): void
    ref(element: HTMLInputElement | null): void
  }
  disabled?: boolean
  focus?: boolean
  autoComplete?: string
}

const M_FieldTextLong = ({
  key = 0, //
  tab = -1,
  type = 'text',
  must = false,
  label,
  labelWidth = 0,
  max = 40,
  valueCode,
  change = undefined,
  blurFunc = undefined,
  register,
  disabled = false,
  focus = false,
  autoComplete = '', // new-passwordで自動入力されない
}: Props) => {
  const classes = useStyles()
  // blurでreducerを変更する場合について
  // chageValueで入力中の値を保持、フォーカスアウトでreducerを更新
  // この入力フォーム以外でreducerが更新されてもchangeValueを変えないと入力フォームの値が変わらないので
  // reducerの値とprevValueRefに持たせた前の値と比較して、変わっていたらchageValueを更新
  const [changeValue, setValue] = useState(valueCode)
  const prevValueRef = useRef<string | undefined>(valueCode)
  // const { isMobileSite } = useMediaQueryContext()
  useEffect(() => {
    if (prevValueRef.current !== valueCode) {
      setValue(valueCode)
      prevValueRef.current = valueCode
    }
  })
  const isBlur = blurFunc !== undefined

  const labelClass = labelWidth === 0 ? classes.label : classes.labelMax
  const textClass = labelWidth === 0 ? classes.text : classes.textLabelMax
  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <Grid item className={clsx(labelClass)}>
        <Typography variant="body1" display="block" gutterBottom>
          {label}
          <A_IconMust must={must} />
        </Typography>
      </Grid>
      <Grid item className={clsx(textClass)}>
        <input
          className={classes.textAtom}
          key={key} //
          tabIndex={tab}
          type={type}
          value={isBlur ? changeValue : valueCode}
          maxLength={max}
          onChange={
            isBlur
              ? (e) => {
                  setValue(e.target.value)
                }
              : change
          }
          onBlur={blurFunc}
          autoFocus={focus}
          {...register}
          autoComplete={autoComplete}
          disabled={disabled}
        />
        {/* <TextField className={classes.textAtom} variant="outlined" /> */}
        {/* <TextField
          key={key} //
          tabIndex={tab}
          type={type}
          value={isBlur ? changeValue : valueCode}
          // maxLength={max}
          inputProps={{
            maxlength: max,
            autoComplete: autoComplete,
            style: {
              height: 27,
              paddingTop: 0,
              paddingBottom: 0,
              backgroundColor: disabled ? '#D8D8D8' : '#FFFFFF',
            },
          }}
          className={classes.textAtom}
          onChange={
            isBlur
              ? (e) => {
                  setValue(e.target.value)
                }
              : change
          }
          onBlur={blurFunc}
          autoFocus={focus}
          {...register}
          variant="outlined"
          size="small"
          disabled={disabled}
        /> */}
      </Grid>
    </Grid>
  )
}
export default React.memo(M_FieldTextLong)
